import { useState } from 'react';
import { Box, Card, Tabs } from '@nimbus-ds/components';
import { SubmitButton } from 'commons/components';
import { combineStatus } from 'commons/utils/combineStatus';
import { useGetIsFreePlan, useStoreStatus } from 'domains/Auth/hooks';
import { useUpdateCharge } from 'domains/Billing/Checkout/hooks';
import { getMainConceptFromCharges } from 'domains/Billing/Checkout/hooks/utils';
import { trackingBillingStartPayment } from 'domains/Billing/Checkout/tracking';
import useTranslationBilling from 'domains/Billing/useTranslationBilling';
import { LastPayments, SelectChargesToPayTab } from './components';
import {
  useNoChargesMessage,
  useSelectCharges,
} from './components/SelectChargesToPayTab/hooks';
import { useManualPaidCharges } from '../../hooks';
import SelectPlanRecurrency from '../SelectPlanRecurrency';

function PaymentsTabs() {
  const t = useTranslationBilling(
    'checkout.plansAndSubscriptions.paymentsTabs',
  );
  const { storeStatus } = useStoreStatus();
  const { isTrial } = useGetIsFreePlan();

  const {
    chargesToSelect,
    status: chargesStatus,
    isCreatingPayOrder,
    onPay,
    selectedCharges,
  } = useSelectCharges();
  const { manualPaidCharges, status } = useManualPaidCharges(
    chargesToSelect?.length === 0,
  );
  const { isLoading } = useUpdateCharge(SelectPlanRecurrency.name);

  const handleOnPay = () => {
    const mainConcept = getMainConceptFromCharges(selectedCharges);
    trackingBillingStartPayment(false, mainConcept);
    onPay();
  };

  const [tabIndex, setTabIndex] = useState(0);

  const { status: noChargesStatus, nextExecutionDate } = useNoChargesMessage();

  const { isSuccess } = combineStatus(status, chargesStatus, noChargesStatus);

  const shouldShowChargesTab =
    chargesToSelect?.length ||
    isTrial ||
    storeStatus === 'store_down' ||
    nextExecutionDate;
  const shouldShowLastPaymentsTab = manualPaidCharges?.length;

  if (isSuccess && !shouldShowChargesTab && !shouldShowLastPaymentsTab)
    return null;

  return (
    <Box display="flex" flexDirection="column" gap="2">
      <Card padding="none">
        <Box marginTop="2">
          <Tabs
            selected={tabIndex}
            onTabSelect={(index) => {
              setTabIndex(index);
            }}
          >
            <Tabs.Item label={t('toPay.tabTitle')}>
              <SelectChargesToPayTab />
            </Tabs.Item>
            <Tabs.Item label={t('lastPayments.tabTitle')}>
              <LastPayments />
            </Tabs.Item>
          </Tabs>
        </Box>
      </Card>

      {tabIndex === 0 && isSuccess && (
        <Box display="flex" justifyContent="flex-end">
          <SubmitButton
            disabled={
              !selectedCharges || selectedCharges.length <= 0 || isLoading
            }
            onClick={handleOnPay}
            isLoading={isCreatingPayOrder}
          >
            {t('toPay.continueToPay')}
          </SubmitButton>
        </Box>
      )}
    </Box>
  );
}

export default PaymentsTabs;
